module.exports = [
  {
    path: '',
    components: {
      default: () => import('@/components/layout/MainLayout.vue')
    },
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: {
          description: 'Olá bem vindo, sou Abraão Pinto, está é minha pagina pessoal. Nela irei contar um pouco das coisas estou aprendendo, sobre tecnologias de frontend como javascript, vuejs, tailwindcss, quasar e backend java, spring.'
        }
      },
      {
        path: '/about',
        name: 'About',
        component: () => import('@/views/About.vue'),
        meta: {
          description: 'Sou Abraão Pinto, venha conhecer um pouco mais sobre mim e as tecnologias utilizadas neste site PWA.'
        }
      },
      {
        path: '/contact',
        name: 'Contact',
        component: () => import('@/views/Contact.vue'),
        meta: {
          description: 'Aqui vocês podem ou mandar um oi.'
        }
      }
    ]
  },
  {
    path: '*',
    components: {
      default: () => import('@/components/layout/SimpleLayout')
    },
    children: [
      {
        path: '/',
        name: 'NotFound',
        component: () => import('@/views/error/NotFound'),
        meta: {
          description: 'Pagina não localizada'
        }
      }
    ]
  }
]
